import './default_module'
import { tooltip, jqTextCopy } from 'javascripts/general_scripts'
import {} from 'bootstrap/js/dist/tab'

/* stylesheet */
import 'stylesheets/users/show.less'

window.gitbTooltip = tooltip;
jqTextCopy();

jQuery(() => {
  if (!HAS_OMNI) {
    import('javascripts/modal_verify');
  }
  $("#small_list").one('mouseover', function() { $.get($(this).data('hoverUrl')) });
});